import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { NgxUnsavedDataManagerService } from './unsaved-data-manager.service';

export const ngxUnsavedDataManagerServiceModule = angular.module('ngxUnsavedDataManagerServiceModule', [])
	.factory('ngxUnsavedDataManagerService', downgradeInjectable(NgxUnsavedDataManagerService) as any)
	.name;
